
import {createSlice} from '@reduxjs/toolkit'
import { fetchintenttype } from '../../action/master/intenttypeAction'

interface intenttypeState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: intenttypeState = {
  data: null,
  status: 'idle',
  error: null,
}

const intenttypeSlice = createSlice({
  name: 'intenttype',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchintenttype.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchintenttype.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchintenttype.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default intenttypeSlice.reducer
